import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { ProjectV2ServiceService } from '../../shared/services/project-v2-service.service';
import { WorkspaceService } from '../../shared/services/workspace.service';
import { AnalyticsService } from '../../shared/services/analytics.service';
import { CryptoService } from '../../shared/services/crypto.service';
import { TimelineService } from '../../shared/services/timeline.service';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { forkJoin, of, Subject, Subscription } from 'rxjs';
import type { WorkspaceDTO } from '../../shared/interfaces/workspace.interface';
import { brandHasWorkspace } from '../../shared/utils/brand-workspace.utils';
import { PermissionService } from '../../shared/services/permissions.service';
import { OverlayService } from '../../shared/services/overlayService';
import { EmitterService } from '../../shared/services/emitter.service';
import { NotificationService } from '../../shared/services/notification.service';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { MtmBreadcrumbLink, MtmBreadcrumbService } from '../../shared/services/mtm-breadcrumb.service';
import { ThemeService } from '../../shared/services/theme.service';
import { GoogleAnalyticsService } from '../../shared/services/google-analytics.service';
import { WORKSPACE_DASHBOARD_ASSETS } from '../../shared/models/campaign-workspace-assets';
import {
  CAMPAIGN_WORKSPACE_COMPONENT_NAMES,
  CAMPAIGN_WORKSPACE_CONSTANTS,
  CAMPAIGN_WORKSPACE_HEADER_LABELS,
  CAMPAIGN_WORKSPACE_ROUTES,
  CAMPAIGN_WORKSPACE_TRANSLATIONS,
} from '../../shared/models/campaign-workspace-translations';
import {
  BrandId,
  BrandUpdatedEvent,
  ErrorValue,
  WorkspaceComponent,
  WorkspaceName,
  WorkspaceV2Id,
} from '../../shared/models';
import { AppStateService, ActivePage } from '../../shared/services/app-state.service';
import { SubsectionService } from '../../shared/services/subsection.service';
import { PLATFORM_CHAT_ENTITY_TYPE } from '../../shared/components/platform-comments-chat/platform-chat-entity.const';
import { PlatformCommentsChatStateService } from '../../shared/services/platform-comments-chat-state.service';
import { PlatformTaskInterfaceStateService } from '../../shared/services/platform-task-interface-state.service';
import { BrandService } from '../../shared/services/brand.service';
@Component({
  selector: 'mtm-workspace-dashboard',
  templateUrl: './workspace-dashboard.component.html',
  styleUrl: './workspace-dashboard.component.scss',
  standalone: false,
})
export class WorkspaceDashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('searchPanel', { static: false }) searchPanel: TemplateRef<any>;
  worskspaceSearch: string;
  private readonly workSpacesSignal = signal<any[]>([]);
  private readonly backupworkSpacesSignal = signal<any[]>([]);
  private readonly isLoadedSignal = signal<boolean>(false);
  private readonly isErrorSignal = signal<boolean>(false);
  private readonly userBrandsSignal = signal<any[]>([]);
  private readonly currentBrandSignal = signal<any>(null);
  favbackupworkSpaces = [];
  favworkSpaces = [];

  get workSpaces(): any[] {
    return this.workSpacesSignal();
  }
  set workSpaces(value: any[]) {
    this.workSpacesSignal.set(value ?? []);
  }

  get backupworkSpaces(): any[] {
    return this.backupworkSpacesSignal();
  }
  set backupworkSpaces(value: any[]) {
    this.backupworkSpacesSignal.set(value ?? []);
  }

  get isLoaded(): boolean {
    return this.isLoadedSignal();
  }
  set isLoaded(value: boolean) {
    this.isLoadedSignal.set(!!value);
  }

  get isError(): boolean {
    return this.isErrorSignal();
  }
  set isError(value: boolean) {
    this.isErrorSignal.set(!!value);
  }

  get userBrands(): any[] {
    return this.userBrandsSignal();
  }
  set userBrands(value: any[]) {
    this.userBrandsSignal.set(value ?? []);
  }

  get currentBrand(): any {
    return this.currentBrandSignal();
  }
  set currentBrand(value: any) {
    this.currentBrandSignal.set(value ?? null);
  }
  isscenario2: boolean = false;
  workspaceImage: any;
  authUser: any;
  ngUnsubscribe = new Subject();
  canCreateWorkspace: boolean = false;
  canManageWorkspace: boolean = false;
  canUpdateWorkspace: boolean = false;
  canDeleteWorkspace: boolean = false;
  brandName: string;
  headerImage: string = WORKSPACE_DASHBOARD_ASSETS.DEFAULT_HEADER_IMAGE;
  imageVersion: string = new Date().getTime().toString();
  calendarViewMode = 'Latest';
  calendarViewLabel = 'latest';
  isAll: boolean = true;
  isFav: boolean = false;
  isArchived: boolean = false;
  isPending: boolean = false;
  cacheBuster: string = Date.now().toString();
  private readonly subscription: Subscription = new Subscription();
  activePage: string = ActivePage.WorkspaceDashboard;
  platformChatEntityType: string = PLATFORM_CHAT_ENTITY_TYPE.BRAND;
  brandParticipants: { email: string }[] = [];
  private readonly platformChatState = inject(PlatformCommentsChatStateService);
  private readonly brandService = inject(BrandService);
  private readonly platformTaskState = inject(PlatformTaskInterfaceStateService);
  constructor(
    private readonly router: Router,
    private readonly workspaceService: WorkspaceService,
    private readonly projectV2ServiceService: ProjectV2ServiceService,
    private readonly authService: AuthService,
    private readonly analyticService: AnalyticsService,
    private readonly cryptoService: CryptoService,
    public readonly timelineService: TimelineService,
    private readonly permissionService: PermissionService,
    private readonly overlayService: OverlayService,
    private readonly themeService: ThemeService,
    private readonly translatePipe: TranslatePipe,
    private readonly notificationService: NotificationService,
    private readonly mtmBreadcrumbService: MtmBreadcrumbService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly appState: AppStateService,
    private readonly subsectionService: SubsectionService
  ) {
    this.setBreadcrumb();
    EmitterService.get(BrandUpdatedEvent)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (brand) => {
          this.setBreadcrumb();
          this.setCurrentSelectedBrand();
        },
      });

    this.workspaceService.workspaceDataEmitter.subscribe(() => {
      this.worskspaceSearch = null;
      this.searchWorkSpace();
    });
  }

  get isCommentPageCommentExpanded(): boolean {
    return (
      this.appState.isEnableCommentPage() && this.appState.isCommentPageCommentExpanded(ActivePage.WorkspaceDashboard)
    );
  }

  ngOnInit(): void {
    this.appState.setActivePage(ActivePage.WorkspaceDashboard);
    this.appState.ensureCommentPageExpandedOnFirstLoad(ActivePage.WorkspaceDashboard);

    this.subsectionService.updateSubsectionState({
      section: null,
      subsection: null,
      activeFile: null,
      activePage: null,
      activeFilePages: null,
      versionData: null,
      comment: null,
      viewMode: null,
      reviewLink: null,
    });

    // resetTab
    this.setCurrentSelectedBrand();
    this.timelineService.resetTabsEmmiter.emit(true);

    this.timelineService.workspaceDashboardEmitter.next(true);
    this.timelineService.isDriveNav.emit(true);

    this.authUser = this.authService.getAuthUser();
    // this.getWorkspaces();
    this.getBrands();

    // get workspace from side bar nav
    this.getSideNavWorkspace();

    // trigger search emmiter
    this.searchWorkSpace();

    // trigger tabs
    const isAgencyUser = this.authUser.userPermissionType === CAMPAIGN_WORKSPACE_CONSTANTS.AGENCY;
    if (!isAgencyUser) {
      this.canCreateWorkspace = this.permissionService.canCreateWorkspace();
      this.canManageWorkspace = this.permissionService.isPlatformAdminOrAccountManager();
      this.canUpdateWorkspace = this.permissionService.canUpdateWorkspace();
      this.canDeleteWorkspace = this.permissionService.canDeleteWorkspace();
    }
    const activeWs = this.workspaceService.getActiveWorkspace();
    if (activeWs) {
      this.workspaceService.unsetActiveWorkspace();
    }

    this.timelineService.driveCampaignData = null;
  }

  ngAfterViewInit() {
    this.themeService.updateContent({
      searchPanel: this.searchPanel,
      fullWidthContent: true,
    });
  }

  ngOnDestroy(): void {
    this.appState.setActivePage(null);
    this.subsectionService.updateSubsectionState(null);
    this.mtmBreadcrumbService.setLinks([]);
    this.themeService.updateContent({
      searchPanel: null,
      standaloneSearch: null,
      fullWidthContent: false,
    });
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
    this.subscription.unsubscribe();
  }

  getBrands() {
    this.workSpaces = [];
    this.backupworkSpaces = [];
    this.isError = false;
    this.isLoaded = false;

    const brands$ = this.analyticService.getBrands();
    const favorites$ = this.analyticService.getFavoriteItem(CAMPAIGN_WORKSPACE_CONSTANTS.FAVORITE_TYPE);

    forkJoin([brands$, favorites$])
      .pipe(
        switchMap(([brands, favorites]: [any, any]) => {
          this.userBrands = brands;
          // The selected brand wins, then the user's default, then the first brand. The previous
          // predicate (`b.id == stored || authUser?.brandId`) was truthy for brands[0] regardless
          // of the stored id, so every load overwrote a brand switch with brands[0].
          const storedBrandId = localStorage.getItem(BrandId);
          const myBrand =
            brands.find((b) => b.id === storedBrandId) ??
            brands.find((b) => b.id === this.authUser?.brandId) ??
            brands[0];

          if (myBrand) {
            localStorage.setItem(BrandId, myBrand.id);
            this.authService.setMyBrand(myBrand);
            EmitterService.get(BrandUpdatedEvent).emit(myBrand);
          }

          const brand = this.authService.getUserBrand() ?? myBrand;

          // Banner follows the active brand — it used to be whichever brand came last in the list
          this.timelineService.componentName.next({
            componentName: WorkspaceComponent,
            bannerUrl: brand?.banner,
          });
          this.refreshImageVersion();

          // Only the active brand's workspaces; GET /api/brands lists ids, so load them per brand.
          const workspaces$ = brand ? this.analyticService.getBrandWorkspaces(brand.id) : of([]);
          return workspaces$.pipe(map((workspaces: WorkspaceDTO[]) => ({ brand, favorites, workspaces })));
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: ({ brand, favorites, workspaces }) => {
          const brandWorkspaces = workspaces.map((workspace) => ({
            ...workspace,
            brandName: brand?.name,
            isFavorite: favorites.some((w) => w.id === workspace.id),
            name: workspace.name?.trim() ?? '',
          }));

          this.workSpaces = [...brandWorkspaces];
          this.backupworkSpaces = [...brandWorkspaces];
          this.favbackupworkSpaces = [...this.backupworkSpaces];
          this.favworkSpaces = [...this.workSpaces];

          this.isLoaded = true;
          this.themeService.updateContent({
            standaloneSearch: this.userBrands.length > 1,
          });
        },
        error: (err) => {
          this.isError = true;
          console.error('An error occurred:', err);
        },
        complete: () => {
          console.info('complete');
        },
      });
  }

  searchWorkSpace() {
    if (!this.worskspaceSearch) {
      this.workSpaces = [...this.backupworkSpaces]; // Ensure it resets properly
    } else {
      const searchLower = this.worskspaceSearch.toLowerCase();
      this.workSpaces = this.backupworkSpaces.filter(
        (workSpace) => workSpace.name?.toLowerCase().includes(searchLower) // Direct check with optional chaining
      );
    }
    this.filterWorkspaceByBrand();
  }

  // get selected workspace from side bar
  getSideNavWorkspace() {
    this.timelineService.selectedWorkspace.subscribe((wk: any) => {
      if (wk?.id) {
        this.goToCampaignDrive(wk);
      }
    });
  }

  goToCampaignDrive(workspace: any) {
    // set active workspace
    this.workspaceService.setActiveWorkspace(workspace);
    localStorage.setItem(WorkspaceComponent, workspace.id);
    localStorage.setItem(WorkspaceName, workspace.name);
    this.workspaceService.changeStatus(true);
    this.workspaceService.changeStatus(true);
    this.timelineService.componentName.next({
      componentName: CAMPAIGN_WORKSPACE_COMPONENT_NAMES.CAMPAIGN_DRIVE_COMPONENT,
      bannerUrl: workspace.coverUrl,
    });
    this.router.navigate([CAMPAIGN_WORKSPACE_ROUTES.CAMPAIGN_DRIVE], {
      queryParams: {
        wid: this.cryptoService.encryptString(workspace.id),
      },
    });

    this.timelineService.workspaceBannerEmitter.emit(workspace.coverUrl);
    this.timelineService.componentName.next({
      componentName: CAMPAIGN_WORKSPACE_COMPONENT_NAMES.CAMPAIGN_DRIVE_COMPONENT,
      bannerUrl: workspace.coverUrl,
    });
    this.timelineService.workspaceName = workspace.name;
    const encryptedWId = this.cryptoService.encryptString(workspace.id);
    localStorage.setItem(WorkspaceV2Id, encryptedWId);
    this.projectV2ServiceService.workspaceIdSubject.next(workspace.id);

    //update selected milestone to null
    this.timelineService.updateMilestone({});

    this.timelineService.isDriveNav.emit(false);
  }

  createWorkspace() {
    this.router.navigate([CAMPAIGN_WORKSPACE_ROUTES.NEW_WORKSPACE]);
  }

  editWorkspace(item) {
    this.router.navigate([CAMPAIGN_WORKSPACE_ROUTES.EDIT_WORKSPACE, item.id]);
  }

  private refreshImageVersion() {
    this.imageVersion = new Date().getTime().toString();
  }

  getFavoriteWorkspace() {
    this.workSpaces = [];
    this.backupworkSpaces = [];
    this.isError = false;
    this.isLoaded = false;
    this.analyticService
      .getFavoriteItem(CAMPAIGN_WORKSPACE_CONSTANTS.FAVORITE_TYPE)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: any) => {
          // set response direct when fav tab is triggered
          if (this.isFav) {
            this.workSpaces = [...res];
            this.backupworkSpaces = [...res];
            this.workSpaces.forEach((workspace) => {
              workspace.isFavorite = res.some((w) => w.id === workspace.id);
            });
            this.backupworkSpaces.forEach((workspace) => {
              workspace.isFavorite = res.some((w) => w.id === workspace.id);
            });
            this.isLoaded = true;
          } else if (this.isAll) {
            // if All is triggered then filter fav data and highlight fav items
            this.favworkSpaces.forEach((workspace) => {
              workspace.isFavorite = res.some((w) => w.id === workspace.id);
            });
            this.favbackupworkSpaces.forEach((workspace) => {
              //   const foundWorkspace = res.find(w => w.id === workspace.id);
              //   workspace.isFavorite = foundWorkspace !== undefined;
              workspace.isFavorite = res.some((w) => w.id === workspace.id);
            });
            // remove duplicate items
            this.workSpaces = this.favworkSpaces.filter(
              (value, index, self) => index === self.findIndex((t) => t.id === value.id)
            );
            this.backupworkSpaces = this.favbackupworkSpaces.filter(
              (value, index, self) => index === self.findIndex((t) => t.id === value.id)
            );
            this.filterWorkspaceByBrand();
            this.isLoaded = true;
          }
        },

        error: (err) => {
          console.error(err);
          this.isError = true;
        },
        complete: () => {
          // Handle completion if needed
        },
      });
  }

  filterWorkspaceByBrand() {
    const brand = this.authService.getUserBrand();
    if (!brand) {
      return;
    }
    this.workSpaces = this.workSpaces.filter((w) => {
      return brandHasWorkspace(brand, w.id);
    });
  }

  // Helper method to set isFavorite status based on a set of favorite workspace IDs
  setFavoriteStatus(array: any[], favoriteWorkspaces: any[]): void {
    array.forEach((workspace) => {
      workspace.isFavorite = favoriteWorkspaces.some((w) => w.id === workspace.id);
    });
  }

  shouldShowEllipsis(name: string): boolean {
    return name.length > 12;
  }

  deleteWorkspace(ws: any) {
    if (this.isPending) {
      return;
    }

    this.notificationService
      .open({
        title: this.translatePipe.transform(CAMPAIGN_WORKSPACE_TRANSLATIONS.WORKSPACE_DELETE_TITLE),
        description: this.translatePipe.transform(CAMPAIGN_WORKSPACE_TRANSLATIONS.WORKSPACE_DELETE_CONFIRM, {
          name: ws.name,
        }),
        confirmBtn: this.translatePipe.transform(CAMPAIGN_WORKSPACE_TRANSLATIONS.YES),
        cancelBtn: this.translatePipe.transform(CAMPAIGN_WORKSPACE_TRANSLATIONS.NO),
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((confirm: boolean) => {
        if (!confirm) {
          return;
        }
        this.isPending = true;
        this.workspaceService
          .deleteWorkspace(ws.companyId, ws.id)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: () => {
              this.isPending = false;
              this.analyticService.clearAnalyticsCache();
              this.getBrands();
            },
            error: (err) => {
              this.isPending = false;
              this.overlayService.showError(this.translatePipe.transform(err.message), ErrorValue);
            },
          });
      });
  }

  setBreadcrumb() {
    const brand = this.authService.getUserBrand();
    if (brand) {
      const pageLinks: MtmBreadcrumbLink[] = [
        { label: brand.name, url: ['/'] },
        { label: CAMPAIGN_WORKSPACE_HEADER_LABELS.WORKSPACES, url: [CAMPAIGN_WORKSPACE_ROUTES.WORKSPACES] },
      ];
      this.mtmBreadcrumbService.setLinks(pageLinks);
      this.googleAnalyticsService.sendUserAnalyticsConfig('', '', '');
    }
  }

  setCurrentSelectedBrand() {
    this.currentBrand = this.authService.getUserBrand();
    this.setPlatformChatContext();
    this.loadBrandParticipants();
  }

  // Brand payloads no longer carry usernamesRoles — the chat participant list comes from
  // the brand-users endpoint instead (same pattern as the campaign-drive overview).
  private loadBrandParticipants(): void {
    const brandId: string | undefined = this.currentBrand?.id;
    if (!brandId) {
      this.brandParticipants = [];
      return;
    }
    this.brandService
      .getBrandUsers(brandId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((users) => {
        const emailsSet = new Set<string>();
        const participants: { email: string }[] = [];
        (users ?? []).forEach((user) => {
          const email = user.email || user.username || '';
          const normalized = email.toLowerCase();
          if (normalized && !emailsSet.has(normalized)) {
            emailsSet.add(normalized);
            participants.push({ email });
          }
        });
        this.brandParticipants = participants;
        this.setPlatformChatContext();
      });
  }

  private setPlatformChatContext(): void {
    this.platformChatState.setContext({
      entityType: this.platformChatEntityType,
      pageId: this.currentBrand?.id,
      entityName: this.currentBrand?.name,
      participants: this.brandParticipants,
      // Brand chat always uses the drive feed: the BRAND drive directory's uuid
      // is pinned to the brand id by the backend hierarchy materialization.
      driveAnchorUuid: this.currentBrand?.id ?? null,
    });
    this.platformTaskState.setContext({
      entityType: this.platformChatEntityType,
      pageId: this.currentBrand?.id,
      entityName: this.currentBrand?.name,
    });
  }
}
